/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

// Vertically aligns the nav item contents in horizontal-nav
export const HorizontalNavItem = styled.div<{
  marginLeft?: number;
}>`
  display: flex;
  align-items: center;
  margin-left: ${props => (props.marginLeft ? props.marginLeft : 0)}px;
`;
